import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import type { DecisionView, IntelligenceView, SystemRecordView } from "@shared/types";
import { StatusPill } from "../components/Status";

export function Insights() {
  const [view, setView] = useState<SystemRecordView | null>(null);
  useEffect(() => {
    api<SystemRecordView>("/api/systems/ross-river").then(setView).catch(() => setView(null));
  }, []);
  const intel: IntelligenceView[] = view?.intelligence ?? [];
  const decisions: DecisionView[] = view?.decisions ?? [];
  return (
    <section className="page-hero">
      <div className="wrap">
        <p className="kicker">Insights</p>
        <h1>What the network currently holds.</h1>
        <p className="lede">Intelligence objects are inspectable. They are not scores.</p>
        <div className="grid-2">
          {intel.map((i) => (
            <article className="card" key={i.id}>
              <StatusPill status={i.epistemic} />
              <h3>{i.title}</h3>
              <p>{i.statement}</p>
            </article>
          ))}
        </div>
        <h2 style={{ marginTop: 48 }}>Decision dependencies</h2>
        {decisions.map((d) => (
          <article className="ev-item" key={d.id} id={d.id}>
            <StatusPill status={d.epistemic} />
            <h3>{d.title}</h3>
            <p>{d.summary}</p>
          </article>
        ))}
        <p style={{ marginTop: 24 }}>
          <Link to="/compare">Compare 2013 and 2021 model generations</Link>
        </p>
      </div>
    </section>
  );
}
